import { RouteObject } from 'react-router';

import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';

export const payerRoutes: RouteObject[] = [
  {
    index: true,
    lazy: () =>
      import('./management/PayerManagementRoute').then((m) => ({
        Component: m.PayerManagementRoute,
      })),
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute routePath="/payers" linkText="Go back to payers" />
    ),
  },
];
